import React, { useEffect, useRef, useState } from "react";
import {
  AiOutlineArrowLeft,
  AiOutlineArrowRight,
  AiOutlineCrown,
  AiOutlineDeliveredProcedure,
  AiOutlineSecurityScan,
} from "react-icons/ai";
import { NavLink } from "react-router-dom";

import Category from "../components/Category";
import Product from "../components/Product";
import Service from "../components/Service";
import Post from "../components/Post";
import Banner from "../components/Banner";

import { apiURL } from "../api";

function Home(props) {
  const scrollCategories = useRef();
  const scrollProducts = useRef();
  const scrollServices = useRef();
  const scrollPosts = useRef();
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");

  const LoadPage = async () => {
    try {
      const res = await fetch(`${apiURL}/check`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      });

      const data = await res.json();
      setCity(data.city);
      setName(data.name);
      setAddress(data.address);
      setName(data.name);
    } catch (error) {
      console.log("User is Not Login");
    }
  };
  useEffect(() => {
    LoadPage();
  }, []);

  return (
    <div className="font-primary">
      <Banner />
      {/* categories */}
      <div className="flex justify-center h-40 items-center w-[90%] mx-auto">
        <button
          onClick={() => scrollCategories.current.scrollBy(-200, 0)}
          className="bg-slate-300 rounded-full p-2"
        >
          <AiOutlineArrowLeft />
        </button>
        <div
          ref={scrollCategories}
          className="overflow-hidden flex justify-start items-center h-full scrollbar-hide whitespace-nowrap scroll-smooth"
        >
          {props.categories.map((category) => {
            return (
              <div key={category.id}>
                <Category category={category} products={props.products} />
              </div>
            );
          })}
        </div>
        <button
          onClick={() => scrollCategories.current.scrollBy(200, 0)}
          className="bg-slate-300 rounded-full p-2"
        >
          <AiOutlineArrowRight />
        </button>
      </div>
      {/* our tools and equipments */}
      <div className="flex justify-between items-center pt-10 mx-auto w-[90%]">
        <h2 className="md:text-2xl text-lg text-primary">
          Our Tools & Equipment's
        </h2>
        <div className="md:block hidden">
          <NavLink
            to="/shop"
            className="mr-4 pt-3 pb-3 pl-6 pr-6 text-primary bg-blue-50 outline-none border rounded-full border-primary"
          >
            Batteries
          </NavLink>
          <NavLink to="/shop" className="home-navlink">
            Tires
          </NavLink>
          <NavLink to="/shop" className="home-navlink">
            Motors
          </NavLink>
          <NavLink to="/shop" className="home-navlink">
            Helmets
          </NavLink>
        </div>
      </div>
      <div className="flex justify-center h-full pt-10 pb-10 items-center w-[90%] mx-auto">
        <button
          onClick={() => scrollProducts.current.scrollBy(-295, 0)}
          className="bg-slate-300 rounded-full p-2"
        >
          <AiOutlineArrowLeft />
        </button>
        <div
          ref={scrollProducts}
          className="overflow-hidden flex justify-start items-center h-full scrollbar-hide whitespace-nowrap scroll-smooth"
        >
          {props.products.map((product) => {
            return (
              <div key={product._id}>
                <Product product={product} />
              </div>
            );
          })}
        </div>
        <button
          onClick={() => scrollProducts.current.scrollBy(295, 0)}
          className="bg-slate-300 rounded-full p-2"
        >
          <AiOutlineArrowRight />
        </button>
      </div>
      {/* Our Services */}
      <div className="flex justify-between items-center pb-5 pt-10 mx-auto w-[90%]">
        <h2 className="md:text-2xl text-lg text-primary">
          Expert Mechanic Services
        </h2>
        <div className="md:block hidden">
          <NavLink
            to="/services"
            className="mr-4 pt-3 pb-3 pl-6 pr-6 text-primary bg-blue-50 outline-none border rounded-full border-primary"
          >
            Cars
          </NavLink>
          <NavLink to="/services" className="home-navlink">
            Generators
          </NavLink>
          <NavLink to="/services" className="home-navlink">
            Bikes
          </NavLink>
        </div>
      </div>
      <div className="flex justify-center h-full pt-6 pb-20 items-center w-[90%] mx-auto">
        <button
          onClick={() => scrollServices.current.scrollBy(-295, 0)}
          className="bg-slate-300 rounded-full p-2"
        >
          <AiOutlineArrowLeft />
        </button>
        <div
          ref={scrollServices}
          className="overflow-hidden flex justify-start items-center h-full scrollbar-hide whitespace-nowrap scroll-smooth"
        >
          {props.services.map((service) => {
            return (
              <div key={service._id}>
                <Service
                  service={service}
                  name={name}
                  address={address}
                  city={city}
                />
              </div>
            );
          })}
        </div>
        <button
          onClick={() => scrollServices.current.scrollBy(200, 0)}
          className="bg-slate-300 rounded-full p-2"
        >
          <AiOutlineArrowRight />
        </button>
      </div>
      {/* Our Goals */}
      <div className="bg-background w-[90%] mx-auto flex flex-wrap md:h-auto h-96 pt-10 pb-10 justify-around text-left rounded-2xl items-center">
        <div className="flex justify-center items-center">
          <AiOutlineDeliveredProcedure color="#EDA415" size="50" />
          <div className="pl-4">
            <h3 className="text-lg text-primary font-semibold">
              Free Delivery
            </h3>
            <p className="text-primary">an order above $500</p>
          </div>
        </div>
        <div className="flex justify-center items-center">
          <AiOutlineCrown color="#EDA415" size="50" />
          <div className="pl-4">
            <h3 className="text-lg text-primary font-semibold">Best Quality</h3>
            <p className="text-primary">best quality in low price</p>
          </div>
        </div>
        <div className="flex justify-center items-center">
          <AiOutlineSecurityScan color="#EDA415" size="50" />
          <div className="pl-4">
            <h3 className="text-lg text-primary font-semibold">
              1 Year Warranty
            </h3>
            <p className="text-primary">avaliable warranty</p>
          </div>
        </div>
      </div>
      {/* blogs */}
      <div className="pt-20 pb-8 w-[90%] mx-auto flex justify-between text-primary">
        <h1 className="text-2xl">Latest Posts</h1>
        <h1 className="text-lg">
          <NavLink to="blog">view all</NavLink>
        </h1>
      </div>
      <div className="flex justify-center h-full pt-6 pb-20 items-center w-[90%] mx-auto">
        <button
          onClick={() => scrollPosts.current.scrollBy(-200, 0)}
          className="bg-slate-300 rounded-full p-2"
        >
          <AiOutlineArrowLeft />
        </button>
        <div
          ref={scrollPosts}
          className="overflow-hidden text-primary flex justify-start items-center h-full scrollbar-hide whitespace-nowrap scroll-smooth"
        >
          {props.posts.map((post) => {
            return (
              <div key={post._id}>
                <Post post={post} />
              </div>
            );
          })}
        </div>
        <button
          onClick={() => scrollPosts.current.scrollBy(200, 0)}
          className="bg-slate-300 rounded-full p-2"
        >
          <AiOutlineArrowRight />
        </button>
      </div>
    </div>
  );
}

export default Home;
